// Library Methods
import { useTranslation } from "react-i18next";

// Components
import { Grid, Typography, Radio, FormControlLabel } from "@mui/material";
import CustomSwitch from "../../../../../../components/UI/CustomSwitch";
import TitleWithTooltip from "../../../../../../components/UI/TitleWithTooltip";

// Enums
import { eyeTypes } from "../../../../../../enums";

const WhichEyeSection = ({
  isActive,
  isRightFirst,
  eyeCheckboxes,
  onChangeSectionOrder,
  onChangeEye,
  isHidden = false,
}) => {
  const { t } = useTranslation();
  const { eyeLeft, eyeRight, eyeBoth } = eyeTypes;

  const bothEyesChecked = eyeCheckboxes.right && eyeCheckboxes.left;
  const rightEyeChecked = eyeCheckboxes.right && !eyeCheckboxes.left;
  const leftEyeChecked = !eyeCheckboxes.right && eyeCheckboxes.left;

  const showRightFirst = bothEyesChecked && !isHidden;

  const textStyle = {
    color: isActive ? "#FFF" : "#5B6D7A",
    fontSize: "14px",
  };

  const EyeOption = ({ eye, isChecked, handleChange }) => {
    return (
      <Grid item display="flex" alignItems="center">
        <Radio
          checked={isChecked && isActive}
          onChange={handleChange}
          value="a"
          name="radio-buttons"
          inputProps={{ "aria-label": eye }}
          sx={{
            "&.MuiButtonBase-root.MuiRadio-root": {
              color: isActive ? "#E2772E" : "#435B6D7A",
            },
          }}
          disabled={!isActive}
        />
        <Typography fontSize="14px" color={isActive ? "#FFF" : "#5B6D7A"}>
          {t(`word_${eye.toLowerCase()}`)}
        </Typography>
      </Grid>
    );
  };

  return (
    <Grid
      container
      item
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      visibility={!isHidden ? "visible" : "hidden"}
    >
      <TitleWithTooltip
        title={t("word_which_eye")}
        tooltip={t("eye_test_tooltip")}
        titleStyle={textStyle}
        tooltipStyle={textStyle}
      />
      <Grid
        container
        item
        xs
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid
          item
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <EyeOption
            eye={eyeBoth}
            isChecked={bothEyesChecked}
            handleChange={() => {
              // reset isRightFirst to true when checking Both option
              onChangeEye(eyeBoth);
              onChangeSectionOrder(true);
            }}
          />
          <EyeOption
            eye={eyeLeft}
            isChecked={leftEyeChecked}
            handleChange={() => onChangeEye(eyeLeft)}
          />
          <EyeOption
            eye={eyeRight}
            isChecked={rightEyeChecked}
            handleChange={() => onChangeEye(eyeRight)}
          />
        </Grid>
      </Grid>
      <Grid
        item
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        width="100%"
        height="30px"
      >
        <FormControlLabel
          sx={{
            visibility: showRightFirst ? "visible" : "hidden",
            marginRight: 0,
            "& .MuiFormControlLabel-label": {
              fontSize: "14px",
              marginLeft: "0px",
              color: isActive ? "#FFF" : "#5B6D7A",

              "&.Mui-disabled": {
                color: "#5B6D7A",
              },
            },
          }}
          control={
            <CustomSwitch
              checked={isRightFirst}
              onChange={(e) => onChangeSectionOrder(e.target.checked)}
              disabled={!isActive}
            />
          }
          label={t("exams_modal_right_first")}
        />
      </Grid>
    </Grid>
  );
};

export default WhichEyeSection;
